import React, { useState } from "react"
import { PageContainerWrapper } from "../App"
import {
	Box,
	Dialog,
	DialogContent,
	DialogContentText,
	DialogTitle,
	IconButton,
	Typography,
} from "@mui/material"
import { faqObj, faqObjType } from "../assets/obj/obj"
import CloseIcon from "@mui/icons-material/Close"

const FaqPage = () => {
	const [modalObj, setModalObj] = useState<faqObjType>()
	const showModalText = (faqObj: faqObjType | undefined) => {
		setModalObj(faqObj)
	}

	return (
		<PageContainerWrapper>
			<Typography variant="h4" paragraph>
				Здесь Вы найдете ответы на часто задаваемые вопросы.
			</Typography>
			{faqObj.map((obj, index) => {
				return (
					<Typography
						key={index}
						onClick={() => showModalText(obj)}
						gutterBottom
						sx={{ cursor: "pointer" }}
					>
						{obj.title}
					</Typography>
				)
			})}
			<Dialog open={!!modalObj} onClose={() => setModalObj(undefined)}>
				<DialogTitle id="alert-dialog-title">
					<Box
						sx={{
							display: "flex",
							alignItems: "center",
							justifyContent: "space-between",
						}}
					>
						<Typography variant="h5">{modalObj?.title}</Typography>
						<IconButton onClick={() => setModalObj(undefined)}>
							<CloseIcon />
						</IconButton>
					</Box>
				</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						{modalObj?.textList.map((paragraf, index) => (
							<Typography key={index} paragraph>
								{paragraf}
							</Typography>
						))}
					</DialogContentText>
					<Box sx={{ width: "100%", overflow: "hidden" }}>
						{modalObj?.img && (
							<img
								src={modalObj?.img}
								alt="man svg"
								style={{ maxWidth: "100%" }}
							/>
						)}
					</Box>
				</DialogContent>
			</Dialog>
		</PageContainerWrapper>
	)
}

export default FaqPage
